import { DocumentStatus, IDigitalizationDocumentDetails } from 'types';

export enum DigiDocuProcessingStep {
  UPLOAD_DONE,
  METADATA_INSPECTION,
  FORMAL_CONTROL,
  QUALITY_CHECK,
  RECORD_LIBRARY_TRANSFER,
}

export function getCurrentDigitalizationDocumentProcessingStep(
  document: IDigitalizationDocumentDetails,
): DigiDocuProcessingStep {
  switch (document.documentProcessingStatus) {
    case DocumentStatus.METADATA_INSPECTION:
      return DigiDocuProcessingStep.METADATA_INSPECTION;
    case DocumentStatus.FORMAL_CONTROL:
      return DigiDocuProcessingStep.FORMAL_CONTROL;
    case DocumentStatus.QUALITY_CHECK:
      return DigiDocuProcessingStep.QUALITY_CHECK;
    case DocumentStatus.RECORD_LIBRARY_TRANSFER_IN_PROGRESS:
      return DigiDocuProcessingStep.RECORD_LIBRARY_TRANSFER;
    case DocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED:
      return DigiDocuProcessingStep.RECORD_LIBRARY_TRANSFER;
    case DocumentStatus.RECORD_LIBRARY_TRANSFER_SUCCESSFULL:
      return DigiDocuProcessingStep.RECORD_LIBRARY_TRANSFER;
  }
}

export function isStepFailed(documentStatus: DocumentStatus): boolean {
  return [DocumentStatus.RECORD_LIBRARY_TRANSFER_FAILED].includes(
    documentStatus,
  );
}
